import React from 'react';
import { useLanguage } from '../../../contexts/LanguageContext';
import { formatDate, formatTimeFromHKT } from './utils/appointmentUtils';

const ConfirmAppointmentOfferEventValue = ({ event }) => {
  const { t } = useLanguage();
  const { value } = event;

  const getStatusIcon = (status) => {
    switch (status?.toLowerCase()) {
      case 'confirmed':
        return '✅';
      case 'cancelled':
        return '❌';
      case 'pending':
        return '⏳';
      default:
        return '📋';
    }
  };

  const getStatusText = (status) => {
    switch (status?.toLowerCase()) {
      case 'confirmed':
        return t('confirmAppointment.confirmed');
      case 'cancelled':
        return t('confirmAppointment.cancelled');
      case 'pending':
        return t('confirmAppointment.pending');
      default:
        return status || t('confirmAppointment.unknownStatus');
    }
  };

  const getStatusColor = (status) => {
    switch (status?.toLowerCase()) {
      case 'confirmed':
        return 'text-green-600';
      case 'cancelled':
        return 'text-red-600';
      case 'pending':
        return 'text-yellow-600';
      default:
        return 'text-gray-600';
    }
  };

  return (
    <div className="space-y-1 text-sm">
      <div className={`font-medium ${getStatusColor(value?.status)}`}>
        {getStatusIcon(value?.status)} {t('confirmAppointment.title')} - {getStatusText(value?.status)}
      </div>
      {value?.doctor_name && (
        <div>👨‍⚕️ {t('confirmAppointment.doctor')}: {value.doctor_name}</div>
      )}
      {value?.appointment_date && (
        <div>📅 {t('confirmAppointment.date')}: {formatDate(value.appointment_date)}</div>
      )}
      {value?.appointment_start_time && value?.appointment_end_time && (
        <div>🕐 {t('confirmAppointment.time')}: {formatTimeFromHKT(value.appointment_start_time)} - {formatTimeFromHKT(value.appointment_end_time)}</div>
      )}
      {value?.location_code && (
        <div>📍 {t('confirmAppointment.location')}: {value.location_code}</div>
      )}

      {/* 系統資訊 - 所有相關的 IDs */}
      {(event.id || value?.confirmed_info_event_id || value?.confirmed_offer_event_id) && (
        <div className="space-y-1">
          <div className="text-xs text-gray-500">{t('confirmAppointment.systemInfo')}:</div>
          {event.id && (
            <div className="text-xs text-blue-600 font-medium">🆔 {t('confirmAppointment.confirmedEventId')}: {event.id}</div>
          )}
          {value?.confirmed_info_event_id && (
            <div className="text-xs text-gray-500">📋 {t('confirmAppointment.appointmentInfoId')}: {value.confirmed_info_event_id}</div>
          )}
          {value?.confirmed_offer_event_id && (
            <div className="text-xs text-gray-500">🗓️ {t('confirmAppointment.appointmentOfferId')}: {value.confirmed_offer_event_id}</div>
          )}
        </div>
      )}
    </div>
  );
};

export default ConfirmAppointmentOfferEventValue;
